export default function sendForm() {
  $('form.sendForm').submit(function(e) {
    e.preventDefault()

    var form = $(this)
    var form_data = new FormData(this)

    $.ajax({
      type: form.attr('method'),
      url: form.attr('action'),
      data: form_data,
      contentType: false,
      cache: false,
      processData: false,
      dataType: 'json',
      error: function(data) {
        console.log('erro')
      },
      success: function(data) {
        if (data.type == 'success') {
          Swal.fire({
            type: 'success',
            title: data.title,
            text: data.html,
          })

          form[0].reset()
        }
      },
    })
  })
}
